import type { FaireProductEntity } from "../../entity_types/product";

export const p_e3kwpeajqn: FaireProductEntity = {
  token: "p_e3kwpeajqn",
  type: "product",
  name: "Are You Over Thinking What I'm Over Thinking? Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/1c22c4cac7f0d6c4fe0f0c401c6e5249f23801e7023f4af130c049f91ba85352.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53f65bc488e3ff1fdfed435ca7fba3eea88bc0a3a4f7ba76c50a9d2ba2c009b1.jpeg",
    "https://cdn.faire.com/fastly/baa363e9de2a651025fe2c67dd367dd4067fdd3448c04f7d2f863b6e6e7a9ced.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/05b30c98239b8b6f691c5ac10cb3586cf9789d5d54bc3e4d4fa546c821c90b1b.jpeg",
    "https://cdn.faire.com/fastly/a3eeb1209142de356a19534ae4b07d544f999f1f7fd8271708c22498dc26b020.jpeg"
  ],
  priceDollars: 6.75,
  description: "We all do that thing every once in a while (all the time) where we spiral into deep thought... and then spiral about spiraling. These socks are ideal for those who get lost in their own head—and need some reassuring comfies to get lost with. 🌀😵 💫\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:57.501Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
